import FirmwareApplicationItemDelegate from "./FirmwareApplicationItemDelegate.js";
import AbstractFotaGroupDelegate from "../AbstractFotaGroupDelegate.js";
export default class FirmwareApplicationGroupDelegate extends AbstractFotaGroupDelegate {
  constructor(options) {
    super(options);
    this.itemDelegateClass = FirmwareApplicationItemDelegate;
  }
  getApi() {
    return this.api.firmwareApplication();
  }
}